import request from '@/utils/request'

export const getInviteRewardConfigList = (params?: { storeId?: number }) =>
  request({
    url: '/invite/rewardConfig/list',
    method: 'get',
    params
  })

export const addInviteRewardConfig = (data: any) =>
  request({
    url: '/invite/rewardConfig',
    method: 'post',
    data
  })

export const updateInviteRewardConfig = (data: any) =>
  request({
    url: '/invite/rewardConfig',
    method: 'put',
    data
  })

export const deleteInviteRewardConfig = (id: number) =>
  request({
    url: `/invite/rewardConfig/${id}`,
    method: 'delete'
  })

export const setInviteRewardConfigEnabled = (id: number, enabled: number) =>
  request({
    url: `/invite/rewardConfig/${id}/enabled`,
    method: 'put',
    params: { enabled }
  })

export interface IInviteRewardLog {
  id: number
  orderId: number
  orderNumber?: string
  inviterId: number
  inviterName?: string
  inviterRemark?: string
  inviterPhone?: string
  inviteeId: number
  inviteeName?: string
  inviteeRemark?: string
  inviteePhone?: string
  bucketCount: number
  rewardAmount: number
  status: number
  createTime?: string
  updateTime?: string
}

export function getInviteRewardLogPage(params: {
  pageNum: number
  pageSize: number
  inviterPhone?: string
  inviteePhone?: string
  status?: number
  storeId?: number
}) {
  return request({
    url: '/invite/rewardLog/page',
    method: 'get',
    params
  })
}
